import React from "react";
import { motion } from "motion/react";

const WipeOverlay = ({ direction = "ltr", onComplete }) => {
  const path =
    direction === "ltr" ? ["-100%", "0%", "100%"] : ["100%", "0%", "-100%"];

  return (
    <motion.div
      style={{
        position: "absolute",
        inset: 0,
        background: "#d8edfe",
        pointerEvents: "none",
        zIndex: 20,
      }}
      initial={{ x: path[0] }}
      animate={{ x: path }}
      transition={{ duration: 0.7, ease: "easeInOut", times: [0, 0.5, 1] }}
      onAnimationComplete={onComplete}
    />
  );
};

export default WipeOverlay;
